var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_293695",
    "data-name": "Group 293695",
    transform: "translate(-304 -843)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 18,
    height: 18,
    transform: "translate(304 843)",
    fill: "#ff13dc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "S_Facebook_18_N",
    d: "M17,9a8,8,0,1,0-9.25,7.9v-5.59H5.719V9H7.75V7.238a2.823,2.823,0,0,1,3.022-3.113,12.3,12.3,0,0,1,1.791.156V6.25H11.554A1.156,1.156,0,0,0,10.25,7.5V9h2.219l-.355,2.313H10.25V16.9A8,8,0,0,0,17,9Z",
    transform: "translate(304 842.999)",
    fill: "#222",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.0cd64a68b43f01cfe9c3d051bb059d59.svg";
export { ForwardRef as ReactComponent };